import { CLIENTS_ROUTER_PATHS, CLIENTS_ROUTER_NAMES } from "./names";

export default [
  {
    path: CLIENTS_ROUTER_PATHS.ITEMS,
    name: CLIENTS_ROUTER_NAMES.ITEMS,
    meta: {
      title: "Список клиентов",
      authRequired: true,
    },
    component: () => import("@/modules/clients/views/items.vue"),
  },
  {
    path: CLIENTS_ROUTER_PATHS.EDIT,
    name: CLIENTS_ROUTER_NAMES.EDIT,
    meta: {
      title: "Клиент",
      authRequired: true,
    },
    component: () => import("@/modules/clients/views/edit.vue"),
  },
  {
    path: CLIENTS_ROUTER_PATHS.CREATE,
    name: CLIENTS_ROUTER_NAMES.CREATE,
    meta: {
      title: "Клиент",
      authRequired: true,
    },
    component: () => import("@/modules/clients/views/edit.vue"),
  },
];
